import { Skeleton } from './skeleton'
import { cn } from '../lib/utils'

export interface TableSkeletonProps {
  rows?: number
  cols?: number
  className?: string
  /** Show a row of header placeholders above the body. Defaults to true. */
  showHeader?: boolean
  /** Render an avatar circle in the first cell (people tables). Defaults to true. */
  firstColAvatar?: boolean
}

export function TableSkeleton({
  rows = 6,
  cols = 5,
  className,
  showHeader = true,
  firstColAvatar = true,
}: TableSkeletonProps) {
  return (
    <div
      role="status"
      aria-label="Loading table"
      aria-busy="true"
      className={cn('w-full', className)}
    >
      {showHeader && (
        <div
          className="grid gap-3 border-b border-border px-4 py-2.5"
          style={{ gridTemplateColumns: `1.5fr repeat(${cols - 1}, 1fr)` }}
        >
          {Array.from({ length: cols }).map((_, i) => (
            <Skeleton key={i} className="h-3 w-16 opacity-60" />
          ))}
        </div>
      )}
      {Array.from({ length: rows }).map((_, r) => (
        <div
          key={r}
          className="grid gap-3 border-b border-border/60 px-4 py-3"
          style={{ gridTemplateColumns: `1.5fr repeat(${cols - 1}, 1fr)` }}
        >
          {firstColAvatar ? (
            <div className="flex items-center gap-2.5">
              <Skeleton className="size-7 rounded-full" />
              <div className="space-y-1.5">
                <Skeleton className="h-3.5 w-20" />
                <Skeleton className="h-2.5 w-12 opacity-60" />
              </div>
            </div>
          ) : (
            <Skeleton className="h-4 w-28" />
          )}
          {Array.from({ length: cols - 1 }).map((_, c) => (
            <Skeleton key={c} className="h-5 w-12 justify-self-end" />
          ))}
        </div>
      ))}
    </div>
  )
}
